import type { AppealStatus, DenialStatus } from '@nexaclaim/shared';

type Status = DenialStatus | AppealStatus;

const STATUS_STYLES: Record<string, string> = {
  // Denial statuses
  new: 'bg-blue-100 text-blue-700',
  in_review: 'bg-amber-100 text-amber-700',
  appeal_drafted: 'bg-purple-100 text-purple-700',
  appeal_submitted: 'bg-indigo-100 text-indigo-700',
  resolved: 'bg-green-100 text-green-700',
  written_off: 'bg-gray-100 text-gray-500',
  // Appeal statuses
  generating: 'bg-amber-100 text-amber-700',
  generation_failed: 'bg-red-100 text-red-700',
  ready_for_review: 'bg-blue-100 text-blue-700',
  citation_verification_failed: 'bg-red-100 text-red-700',
  approved: 'bg-emerald-100 text-emerald-700',
  submitted: 'bg-green-100 text-green-700',
  superseded: 'bg-gray-100 text-gray-500',
};

const STATUS_LABELS: Record<string, string> = {
  new: 'New',
  in_review: 'In Review',
  appeal_drafted: 'Appeal Drafted',
  appeal_submitted: 'Appeal Submitted',
  resolved: 'Resolved',
  written_off: 'Written Off',
  generating: 'Generating',
  generation_failed: 'Generation Failed',
  ready_for_review: 'Ready for Review',
  citation_verification_failed: 'Citation Failed',
  approved: 'Approved',
  submitted: 'Submitted',
  superseded: 'Superseded',
};

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-600';
  const label = STATUS_LABELS[status] ?? status;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${style} ${className}`}
    >
      {label}
    </span>
  );
}
